<div class="ajax-loading"><div class="loading-icon"></div></div>
<section class="page-title">
    <h1>VIDEOS</h1>
    <div class="employee-code">
        <button *hasPermission="['video.write']" mat-raised-button mat-raised-button color="primary" class="oms-btn pull-right" (click)="openVideoDialog(videoModel)"> <img src="./assets/images/icon-user-add.svg" alt="">  Add Video </button>
    </div>
</section>
<mat-card class="card-white mb-4 p-0 filter-section">
    <mat-card-title class="mb-0">
        <div class="card-white-title mb-0  cursor-pointer" [class.advanceSearchFilter]="isAdvanceSearchFilter" (click)="onDisplayFilter(null)">
            <div class="card-user-name"> <img src="./assets/images/icon-filter.svg" alt="">  Filter</div>
            <div class="office-hours">
                <a class="box-arrow" (click)="onDisplayFilter($event)" href="javascript:void(0);"></a>
            </div>
        </div>
    </mat-card-title>
    <mat-card-content [hidden]="!isAdvanceSearchFilter">
        <div class="example-form">
            <ul class="filter-list">
                <li>
                  <div class="form-group">
                      <mat-label>Video Category</mat-label>
                        <mat-form-field class="example-full-width">
                          <mat-select [(ngModel)]="selectedVideoCategory" placeholder="Select a video category" (selectionChange)="onVideoCategoryChange($event)">
                            <mat-option *ngFor="let videoCategory of videoCategoryEnum" [value]="videoCategory">{{ videoCategory }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                  </div>
                </li>
                <li *ngIf="selectedVideoCategory === this.videoCategorys.StationSpecific">
                  <div class="form-group">
                      <mat-label>Station</mat-label>
                        <mat-form-field class="example-full-width">
                        <input
                            type="text"
                            matInput
                            placeholder="Select station"
                            [formControl]="stationControl"
                            [matAutocomplete]="auto">
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayStation">
                            <mat-option *ngFor="let station of filteredStation | async" [value]="station">
                            {{  station.crsCode + ' - ' + station.name }}
                            </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                  </div>
                </li>
                <li *ngIf="selectedVideoCategory === this.videoCategorys.StationSpecific">
                  <div class="form-group">
                      <mat-label>Type</mat-label>
                        <mat-form-field class="example-full-width">
                            <mat-select [(ngModel)]="selectedType" placeholder="Select a video type">
                                <mat-option *ngFor="let videoType of videoTypeEnum" [value]="videoType">{{ videoType }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                  </div>
                </li>
                <li *ngIf="selectedVideoCategory === this.videoCategorys.Cancel || selectedVideoCategory === this.videoCategorys.Delay">
                  <div class="form-group">
                      <mat-label>Code</mat-label>
                        <mat-form-field class="example-full-width">
                            <input type="text" matInput placeholder="Enter Code" [(ngModel)]="selectedCode" />
                        </mat-form-field>
                  </div>
                </li>
                <li>
                  <div class="form-group">
                      <mat-label>Status</mat-label>
                      <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedIsActive">
                          <mat-radio-button [value]="true">Active</mat-radio-button>
                          <mat-radio-button [value]="false">Inactive</mat-radio-button>
                        </mat-radio-group>
                  </div>
                </li>
             </ul>
             <div class="filter-action">
                <button class="me-3 btn-outline-black " mat-raised-button color="primary" (click)="clearFilter()" > Clear </button>
                <button class=" btn-black" mat-raised-button color="primary" (click)="applyFilter()" > Apply </button>
             </div>
        </div>
    </mat-card-content>
</mat-card>
<mat-card class="card-white matcardheight">
    <mat-card-content>
        <div class="stiky-table-container ps-table">
            <table class="list-table" mat-table matSort (matSortChange)="sortVideos($event)" matSortActive="name" 
                    matSortDirection="asc" [matSortDisableClear]="true" [dataSource]="dataSource">
                <ng-container matColumnDef="Category">
                    <th mat-header-cell mat-sort-header="Category" *matHeaderCellDef> Category </th>
                    <td mat-cell *matCellDef="let element"> 
                        <span>{{element.category}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="AutoPurge">
                    <th mat-header-cell mat-sort-header="AutoPurge" *matHeaderCellDef> Purge </th>
                    <td mat-cell *matCellDef="let element"> 
                        <span>{{element.autoPurge}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="StationId">
                    <th mat-header-cell mat-sort-header="StationId" *matHeaderCellDef> Station </th>
                    <td mat-cell *matCellDef="let element"> 
                        <span>{{getStationName(element.stationId)}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="Type">
                    <th mat-header-cell mat-sort-header="Type" *matHeaderCellDef> Type </th>
                    <td mat-cell *matCellDef="let element"> 
                        <span>{{element.type}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="Code">
                    <th mat-header-cell mat-sort-header="Code" *matHeaderCellDef> Code </th>
                    <td mat-cell *matCellDef="let element"> 
                        <span>{{element.code}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="IsActive">
                    <th mat-header-cell mat-sort-header="IsActive" *matHeaderCellDef> Status </th>
                    <td mat-cell *matCellDef="let element"> 
                        <div class="form-group">
                            <mat-slide-toggle [disabled]="!isWritePermission" [(ngModel)]="element.isActive" (change)="onToggleChange($event, element.id)"></mat-slide-toggle>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="UpdatedOn">
                    <th mat-header-cell mat-sort-header="UpdatedOn" *matHeaderCellDef> Last Modified</th>
                    <td mat-cell *matCellDef="let element"> 
                        <span>{{getDate(element.updatedOn)}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="Action" *hasPermission="['video.write']">
                    <th mat-header-cell *matHeaderCellDef class="text-center">Actions</th>
                    <td mat-cell *matCellDef="let element">
                        <ul class="action-items text-center">
                            <li class="view-link justify-content-center">
                                <a (click)="openVideoDialog(element)" class="me-3 pt-1" href="javascript:void(0)" title="Edit Video"><img src="./assets/images/icon-edit.svg" alt=""> </a>
                            </li>
                        </ul>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <div *ngIf="videoList.length == 0" class="no-record-found text-center p-3">No record found.</div>
        <mat-paginator [length]="totalItems"
                [showFirstLastButtons]="true"
                [pageSize]="pageSize"
                [pageSizeOptions]="[5, 10, 20]"
                (page)="onPageChange($event)">
        </mat-paginator>
    </mat-card-content>
</mat-card>